
if (!customElements.get('bundle-purchase-card')) {
  class BundlePurchaseCard extends HTMLElement {
    connectedCallback() {
      // Re-run safely if the node is re-inserted (grid-custom rebuilds innerHTML on mobile).
      if (this._bound) return;
      this._bound = true;

      this.variants = this._parseVariants();
      this.idInputs = this.querySelectorAll('.tt-bundle-card__variant-id');
      this.optionLists = this.querySelectorAll('.tt-bundle-card__option');
      this.priceCurrent = this.querySelector('.tt-bundle-card__price-current');
      this.priceCompare = this.querySelector('.tt-bundle-card__price-compare');
      this.discountTag = this.querySelector('.tt-bundle-card__discount-tag');
      this.image = this.querySelector('.tt-bundle-card__image');
      this.atcBtn = this.querySelector('.tt-bundle-card__btn--atc');
      this.atcLabel = this.querySelector('.tt-bundle-card__btn-label');
      this.buyBtn = this.querySelector('.tt-bundle-card__btn--buy');

      this.querySelectorAll('.tt-bundle-card__option-item').forEach((el) => {
        el.addEventListener('click', this._onSelect.bind(this, el));
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this._onSelect(el);
          }
        });
      });
    }

    _parseVariants() {
      const node = this.querySelector('.tt-bundle-card__variants');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        console.warn('bundle-purchase-card: invalid variants JSON', e);
        return [];
      }
    }

    _onSelect(el) {
      const list = el.closest('.tt-bundle-card__option');
      if (!list || el.classList.contains('active')) return;
      list
        .querySelectorAll('.tt-bundle-card__option-item')
        .forEach((i) => i.classList.remove('active'));
      el.classList.add('active');
      this._update();
    }

    _selectedValues() {
      const values = [];
      this.optionLists.forEach((list) => {
        const pos = parseInt(list.dataset.optionPosition, 10);
        const active = list.querySelector('.tt-bundle-card__option-item.active');
        if (active && pos) values[pos - 1] = active.dataset.value;
      });
      return values;
    }

    _update() {
      const selected = this._selectedValues();
      const variant = this.variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selected.length &&
          v.options.every((o, i) => o === selected[i])
      );
      if (!variant) return;

      this.idInputs.forEach((input) => {
        input.value = variant.id;
      });

      if (this.priceCurrent && variant.price_html) {
        this.priceCurrent.innerHTML = variant.price_html;
      }
      if (this.priceCompare) {
        if (variant.has_compare && variant.compare_html) {
          this.priceCompare.innerHTML = variant.compare_html;
          this.priceCompare.style.display = '';
        } else {
          this.priceCompare.style.display = 'none';
        }
      }
      if (this.discountTag) {
        if (variant.has_compare && variant.discount > 0) {
          this.discountTag.textContent = '-' + variant.discount + '%';
          this.discountTag.style.display = '';
        } else {
          this.discountTag.style.display = 'none';
        }
      }
      if (this.image && variant.image) {
        this.image.src = variant.image;
      }

      const available = variant.available === true;
      [this.atcBtn, this.buyBtn].forEach((btn) => {
        if (btn) btn.disabled = !available;
      });
      if (this.atcLabel) {
        this.atcLabel.textContent = available
          ? this.atcBtn?.dataset.addLabel ||
            window.variantStrings?.addToCart ||
            'Add To Cart'
          : this.atcBtn?.dataset.soldLabel ||
            window.variantStrings?.soldOut ||
            'Sold Out';
      }
    }
  }

  customElements.define('bundle-purchase-card', BundlePurchaseCard);
}
